import { useSnackbar } from "notistack";

export function useDefaultToast() {
    const { enqueueSnackbar } = useSnackbar();

    return (msg, opts = {}) => enqueueSnackbar(msg, opts);
}

export function useErrorToast() {
    const { enqueueSnackbar } = useSnackbar();

    return (msg, opts = {}) =>
        enqueueSnackbar(msg, {
            variant: "error",
            ...opts,
        });
}
